import { Capacitor } from '@capacitor/core';

import iosManager from 'app/dotsnake/game/ios-manager';
import webManager from 'app/dotsnake/game/web-manager';

const isIos = Capacitor.getPlatform() === 'ios';
const manager = isIos ? iosManager : webManager;

export default manager;
